"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cache_item_1 = require("./cache-item");
var CacheInstance = /** @class */ (function () {
    function CacheInstance() {
        this._cache = [];
    }
    CacheInstance.prototype.add = function (key, value) {
        var item = this.get(key);
        if (item === undefined) {
            var newItem = new cache_item_1.CacheItem();
            newItem.key = key;
            newItem.value = value;
            this._cache.push(newItem);
            return newItem;
        }
        else {
            item.value = value;
        }
        return item;
    };
    CacheInstance.prototype.remove = function (key) {
        for (var i = 0; i < this._cache.length; i++) {
            if (this._cache[i].key === key) {
                this._cache.splice(i, 1);
            }
        }
    };
    CacheInstance.prototype.removeAll = function () {
        this._cache = [];
    };
    Object.defineProperty(CacheInstance.prototype, "list", {
        get: function () {
            return this._cache;
        },
        enumerable: true,
        configurable: true
    });
    CacheInstance.prototype.get = function (key) {
        for (var _i = 0, _a = this._cache; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.key === key) {
                return item;
            }
        }
        return undefined;
    };
    return CacheInstance;
}());
exports.CacheInstance = CacheInstance;
//# sourceMappingURL=cache-instance.js.map